import { LOCALE_CODE } from './index';

export type HELP_PAGE_ID = typeof HELP_PAGE_ID[keyof typeof HELP_PAGE_ID];

export const HELP_PAGE_ID = {
  /** 가이드 */
  '2896232711757687212': '2896232711757687212', // Dooray! 시작하기
  '2896355093254764715': '2896355093254764715', // 상품 가입/변경하기
  '2896315749455837575': '2896315749455837575', // 프로젝트 만들기
  '2895665124290656041': '2895665124290656041', // 업무
  '2896331873978831114': '2896331873978831114', // 메일을 업무로 등록하기
  '2896457691170642849': '2896457691170642849', // 파일 공유하기(링크 공유)
  '2908862405226743557': '2908862405226743557', // 자체 메일 주소 연동하기 (자체 도메인 설정)
  '2896416687827716068': '2896416687827716068', // 서명 설정
  '2908760783111049972': '2908760783111049972', // 메일 설정
  '2908879250725210621': '2908879250725210621', // 해킹 의심 신고
  '2908919516990399163': '2908919516990399163', // 메일 클라이언트에서 IMAP 설정
  '2908813930688626973': '2908813930688626973', // 메일 백업 (가져오기,내보내기)
  '2940684090377267030': '2940684090377267030', // 공유 캘린더 생성/관리
  '2909022799066354256': '2909022799066354256', // 스마트폰 기본 캘린더 연동
  '2982597483908541026': '2982597483908541026', // 주소록 연동
  '2909396957359293708': '2909396957359293708', // 멤버 초대
  '2911440352193516181': '2911440352193516181', // 단축키 가이드
  '2915468568333408117': '2915468568333408117', // 백업하기
  '3216291598897944508': '3216291598897944508', // 마크다운 도움말
  '2895665675343408345': '2895665675343408345', // 개인 및 공용 용량
  '2895666126052847064': '2895666126052847064', // 공용 용량
  '2895664991100104876': '2895664991100104876', // Admin(관리자)
  '2896232119805738090': '2896232119805738090', // 조직 서비스 관리
  '2896232119805738090#서비스-사용-및-제한': '2896232119805738090#서비스-사용-및-제한', // 서비스 사용 및 제한
  '2896232119805738090#파일-확장자-제한': '2896232119805738090#파일-확장자-제한', // 파일 확장자 제한
  '2896232193326894301': '2896232193326894301', // 구성원/조직도
  '2896232193326894301#멤버': '2896232193326894301#멤버', // 멤버
  '2896232193326894301#손님': '2896232193326894301#손님', // 손님
  '2896232193326894301#조직도': '2896232193326894301#조직도', // 조직도
  '2896232300521846756': '2896232300521846756', // 권한 관리
  '2896232300521846756#기능-권한': '2896232300521846756#기능-권한', // 기능 권한
  '2920400054827245396': '2920400054827245396', // 보안 설정
  '3305783751335460528': '3305783751335460528', // 글타래(스레드)
  '3362253534912554764': '3362253534912554764', // 메신저(PC) 이용 중에도 모바일앱 알림 동시에 받기
  '2900079528873523321': '2900079528873523321', // 슬래시 커맨드

  /** FAQ */
  '2941258434087814244': '2941258434087814244', // 메시지를 수정, 삭제할 수 있나요?
  '2909485101485521881': '2909485101485521881', // 프로젝트 진행률을 알 수 있나요?
  '2909485257333752160': '2909485257333752160', // 누구나 볼 수 있는 프로젝트를 만들고 싶어요
  '2910336717666411815': '2910336717666411815', // 조직 전체의 스팸 규칙을 관리 할 수 있나요?
  '2914546408790482545': '2914546408790482545', // 서명에 이미지를 첨부할 수 없나요?
  '3565932103930442064': '3565932103930442064', // 보안 메일 설정이 궁금해요.
  '2910207042247838122': '2910207042247838122', // 연락처 업로드를 위한 샘플파일이 필요해요.
  '2915755996712602230': '2915755996712602230', // 서비스별 데이터 백업 방법이 궁금해요.
  '3000919820354205619': '3000919820354205619', // 용량 초과시 이용 제한 기능
  '2911145718293613594': '2911145718293613594', // Admin (관리자)
  '2914549113052333191': '2914549113052333191', // 공통 서명 템플릿 설정하기
  '2911149861500475439': '2911149861500475439', // 탈퇴 구성원의 데이터는 어떻게 되나요?

  /** Dooray! API */
  '2937064454837487755': '2937064454837487755', // Dooray! API

  /** 릴리스 노트 */
  '3475524696812012392': '3475524696812012392', // 2024

  /** Dooray! 활용 사례 */
  '2962315498932384699': '2962315498932384699', // Dooray! 활용 사례
  '3604598428095167222': '3604598428095167222', // 개인 업무 관리하기 (개인 프로젝트 활용)
} as const;

export type LOCALE_HELP_PAGE_ID = typeof LOCALE_HELP_PAGE_ID[keyof typeof LOCALE_HELP_PAGE_ID];

export const LOCALE_HELP_PAGE_ID: Record<
  HELP_PAGE_ID,
  Partial<Record<LOCALE_CODE, string>> & { [LOCALE_CODE.KO_KR]: string }
> = {
  [HELP_PAGE_ID['2896232711757687212']]: {
    [LOCALE_CODE.KO_KR]: '2896232711757687212',
    [LOCALE_CODE.EN_US]: '2956641531137299772',
    [LOCALE_CODE.JA_JP]: '2957379814713976860',
  },
  [HELP_PAGE_ID['2896355093254764715']]: {
    [LOCALE_CODE.KO_KR]: '2896355093254764715',
    [LOCALE_CODE.EN_US]: '2956643508415561833',
    [LOCALE_CODE.JA_JP]: '2957380564465812151',
  },
  [HELP_PAGE_ID['2896315749455837575']]: {
    [LOCALE_CODE.KO_KR]: '2896315749455837575',
    [LOCALE_CODE.EN_US]: '2956650156662522532',
    [LOCALE_CODE.JA_JP]: '2957395695032231151',
  },
  [HELP_PAGE_ID['2895665124290656041']]: {
    [LOCALE_CODE.KO_KR]: '2895665124290656041',
    [LOCALE_CODE.EN_US]: '2956649991894192004',
    [LOCALE_CODE.JA_JP]: '2957396573914328411',
  },
  [HELP_PAGE_ID['2896331873978831114']]: {
    [LOCALE_CODE.KO_KR]: '2896331873978831114',
    [LOCALE_CODE.EN_US]: '2956651589786685437',
    [LOCALE_CODE.JA_JP]: '2957396887231094584',
  },
  [HELP_PAGE_ID['2896457691170642849']]: {
    [LOCALE_CODE.KO_KR]: '2896457691170642849',
    [LOCALE_CODE.EN_US]: '2956658311684355313',
    [LOCALE_CODE.JA_JP]: '2957449018327838955',
  },
  [HELP_PAGE_ID['2908862405226743557']]: {
    [LOCALE_CODE.KO_KR]: '2908862405226743557',
    [LOCALE_CODE.EN_US]: '2956659503842424980',
    [LOCALE_CODE.JA_JP]: '2957449820448354094',
  },
  [HELP_PAGE_ID['2896416687827716068']]: {
    [LOCALE_CODE.KO_KR]: '2896416687827716068',
    [LOCALE_CODE.EN_US]: '2956660874041448359',
    [LOCALE_CODE.JA_JP]: '2957450101982267334',
  },
  [HELP_PAGE_ID['2908760783111049972']]: {
    [LOCALE_CODE.KO_KR]: '2908760783111049972',
    [LOCALE_CODE.EN_US]: '2956659681779990371',
    [LOCALE_CODE.JA_JP]: '2957451483147698493',
  },
  [HELP_PAGE_ID['2908879250725210621']]: {
    [LOCALE_CODE.KO_KR]: '2908879250725210621',
    [LOCALE_CODE.EN_US]: '2956660077281294454',
    [LOCALE_CODE.JA_JP]: '2957453701017127520',
  },
  [HELP_PAGE_ID['2908919516990399163']]: {
    [LOCALE_CODE.KO_KR]: '2908919516990399163',
    [LOCALE_CODE.EN_US]: '2956660166444595834',
    [LOCALE_CODE.JA_JP]: '2957454324993474911',
  },
  [HELP_PAGE_ID['2908813930688626973']]: {
    [LOCALE_CODE.KO_KR]: '2908813930688626973',
    [LOCALE_CODE.EN_US]: '2956660422381424555',
    [LOCALE_CODE.JA_JP]: '2957455822227588383',
  },
  [HELP_PAGE_ID['2940684090377267030']]: {
    [LOCALE_CODE.KO_KR]: '2940684090377267030',
    [LOCALE_CODE.EN_US]: '2956665187802633103',
    [LOCALE_CODE.JA_JP]: '2957451500573118042',
  },
  [HELP_PAGE_ID['2909022799066354256']]: {
    [LOCALE_CODE.KO_KR]: '2909022799066354256',
    [LOCALE_CODE.EN_US]: '2956667089431031731',
    [LOCALE_CODE.JA_JP]: '2957454189601492104',
  },
  [HELP_PAGE_ID['2982597483908541026']]: {
    [LOCALE_CODE.KO_KR]: '2982597483908541026',
    [LOCALE_CODE.JA_JP]: '3013771801971644537',
  },
  [HELP_PAGE_ID['2909396957359293708']]: {
    [LOCALE_CODE.KO_KR]: '2909396957359293708',
    [LOCALE_CODE.EN_US]: '2957329722101516027',
    [LOCALE_CODE.JA_JP]: '2957458211896787540',
  },
  [HELP_PAGE_ID['2911440352193516181']]: {
    [LOCALE_CODE.KO_KR]: '2911440352193516181',
    [LOCALE_CODE.EN_US]: '2957329987684020438',
    [LOCALE_CODE.JA_JP]: '2957458852307292751',
  },
  [HELP_PAGE_ID['2915468568333408117']]: {
    [LOCALE_CODE.KO_KR]: '2915468568333408117',
    [LOCALE_CODE.EN_US]: '2957330086174572936',
    [LOCALE_CODE.JA_JP]: '2957459094107497875',
  },
  [HELP_PAGE_ID['3216291598897944508']]: {
    [LOCALE_CODE.KO_KR]: '3216291598897944508',
  },
  [HELP_PAGE_ID['2895665675343408345']]: {
    [LOCALE_CODE.KO_KR]: '2895665675343408345',
    [LOCALE_CODE.EN_US]: '2956644440637061851',
    [LOCALE_CODE.JA_JP]: '2957459354945262121',
  },
  [HELP_PAGE_ID['2895666126052847064']]: {
    [LOCALE_CODE.KO_KR]: '2895666126052847064',
    [LOCALE_CODE.EN_US]: '2957331784527804814',
    [LOCALE_CODE.JA_JP]: '2957459719315389678',
  },
  [HELP_PAGE_ID['2895664991100104876']]: {
    [LOCALE_CODE.KO_KR]: '2895664991100104876',
    [LOCALE_CODE.EN_US]: '2956644561668313637',
    [LOCALE_CODE.JA_JP]: '2957460450108308422',
  },
  [HELP_PAGE_ID['2896232119805738090']]: {
    [LOCALE_CODE.KO_KR]: '2896232119805738090',
    [LOCALE_CODE.EN_US]: '2957334285630749692',
    [LOCALE_CODE.JA_JP]: '2957460804849372922',
  },
  [HELP_PAGE_ID['2896232119805738090#서비스-사용-및-제한']]: {
    [LOCALE_CODE.KO_KR]: '2896232119805738090#서비스-사용-및-제한',
    [LOCALE_CODE.EN_US]: '2957334285630749692#Usage-and-Restrictions',
    [LOCALE_CODE.JA_JP]: '2957460804849372922#サービス使用および制限',
  },
  [HELP_PAGE_ID['2896232119805738090#파일-확장자-제한']]: {
    [LOCALE_CODE.KO_KR]: '2896232119805738090#파일-확장자-제한',
    [LOCALE_CODE.EN_US]: '2957334285630749692#File-Extension-Restrictions',
    [LOCALE_CODE.JA_JP]: '2957460804849372922#ファイル拡張子制限',
  },
  [HELP_PAGE_ID['2896232193326894301']]: {
    [LOCALE_CODE.KO_KR]: '2896232193326894301',
    [LOCALE_CODE.EN_US]: '2957334634604767877',
    [LOCALE_CODE.JA_JP]: '2957460932527469931',
  },
  [HELP_PAGE_ID['2896232193326894301#멤버']]: {
    [LOCALE_CODE.KO_KR]: '2896232193326894301#멤버',
    [LOCALE_CODE.EN_US]: '2957334634604767877#Member',
    [LOCALE_CODE.JA_JP]: '2957460932527469931#メンバー',
  },
  [HELP_PAGE_ID['2896232193326894301#손님']]: {
    [LOCALE_CODE.KO_KR]: '2896232193326894301#손님',
    [LOCALE_CODE.EN_US]: '2957334634604767877#Guests',
    [LOCALE_CODE.JA_JP]: '2957460932527469931#ゲスト',
  },
  [HELP_PAGE_ID['2896232193326894301#조직도']]: {
    [LOCALE_CODE.KO_KR]: '2896232193326894301#조직도',
    [LOCALE_CODE.EN_US]: '2957334634604767877#Organizational-Chart',
    [LOCALE_CODE.JA_JP]: '2957460932527469931#組織図',
  },
  [HELP_PAGE_ID['2896232300521846756']]: {
    [LOCALE_CODE.KO_KR]: '2896232300521846756',
    [LOCALE_CODE.EN_US]: '2957334717085503296',
    [LOCALE_CODE.JA_JP]: '2957461115239866798',
  },
  [HELP_PAGE_ID['2896232300521846756#기능-권한']]: {
    [LOCALE_CODE.KO_KR]: '2896232300521846756#기능-권한',
    [LOCALE_CODE.EN_US]: '2957334717085503296#Feature-Permissions',
    [LOCALE_CODE.JA_JP]: '2957461115239866798#機能権限',
  },
  [HELP_PAGE_ID['2920400054827245396']]: {
    [LOCALE_CODE.KO_KR]: '2920400054827245396',
    [LOCALE_CODE.EN_US]: '3731883188210957686',
    [LOCALE_CODE.JA_JP]: '2957461818420289179',
  },
  [HELP_PAGE_ID['2941258434087814244']]: {
    [LOCALE_CODE.KO_KR]: '2941258434087814244',
  },
  [HELP_PAGE_ID['2909485101485521881']]: {
    [LOCALE_CODE.KO_KR]: '2909485101485521881',
  },
  [HELP_PAGE_ID['2909485257333752160']]: {
    [LOCALE_CODE.KO_KR]: '2909485257333752160',
  },
  [HELP_PAGE_ID['2910336717666411815']]: {
    [LOCALE_CODE.KO_KR]: '2910336717666411815',
  },
  [HELP_PAGE_ID['2914546408790482545']]: {
    [LOCALE_CODE.KO_KR]: '2914546408790482545',
  },
  [HELP_PAGE_ID['3565932103930442064']]: {
    [LOCALE_CODE.KO_KR]: '3565932103930442064',
  },
  [HELP_PAGE_ID['2910207042247838122']]: {
    [LOCALE_CODE.KO_KR]: '2910207042247838122',
  },
  [HELP_PAGE_ID['2915755996712602230']]: {
    [LOCALE_CODE.KO_KR]: '2915755996712602230',
  },
  [HELP_PAGE_ID['3000919820354205619']]: {
    [LOCALE_CODE.KO_KR]: '3000919820354205619',
  },
  [HELP_PAGE_ID['2911145718293613594']]: {
    [LOCALE_CODE.KO_KR]: '2911145718293613594',
  },
  [HELP_PAGE_ID['2914549113052333191']]: {
    [LOCALE_CODE.KO_KR]: '2914549113052333191',
  },
  [HELP_PAGE_ID['2911149861500475439']]: {
    [LOCALE_CODE.KO_KR]: '2911149861500475439',
  },
  [HELP_PAGE_ID['2937064454837487755']]: {
    [LOCALE_CODE.KO_KR]: '2937064454837487755',
  },
  [HELP_PAGE_ID['3475524696812012392']]: {
    [LOCALE_CODE.KO_KR]: '3475524696812012392',
    [LOCALE_CODE.EN_US]: '3475526263844608513',
    [LOCALE_CODE.JA_JP]: '3475525972498629890',
  },
  [HELP_PAGE_ID['2962315498932384699']]: {
    [LOCALE_CODE.KO_KR]: '2962315498932384699',
  },
  [HELP_PAGE_ID['3604598428095167222']]: {
    [LOCALE_CODE.KO_KR]: '3604598428095167222',
  },
  [HELP_PAGE_ID['3305783751335460528']]: {
    [LOCALE_CODE.KO_KR]: '3305783751335460528',
    [LOCALE_CODE.EN_US]: '3305816815573717110',
    [LOCALE_CODE.JA_JP]: '3305836900090579783',
  },
  [HELP_PAGE_ID['3362253534912554764']]: {
    [LOCALE_CODE.KO_KR]: '3362253534912554764',
    [LOCALE_CODE.EN_US]: '3362260598847774909',
    [LOCALE_CODE.JA_JP]: '3362264936765439656',
  },
  [HELP_PAGE_ID['2900079528873523321']]: {
    [LOCALE_CODE.KO_KR]: '2900079528873523321',
    [LOCALE_CODE.EN_US]: '2956645145270154674',
    [LOCALE_CODE.JA_JP]: '2957386213565388402',
  },
} as const;
